<template>
    <section class="recover-password">
      <div class="ls-login-parent">
          <div class="ls-login-container">
            <div class="ls-login-box">
              <router-link :to="{ name: 'auth'}" :title="$t('login.signin')" class="ls-position-absolute"><i class="fa fa-arrow-left ls-color-theme" aria-hidden="true"></i></router-link>
              <h1 class="ls-login-logo">
                <img src="./../../../assets/img/logo.svg" width="140">
              </h1>
              <flash-message></flash-message>
              <h2 class="ls-title-5 ls-txt-center ls-color-theme">{{ $t('login.forgot_your_password') }}</h2>
              <p class="ls-txt-center">{{ $t('login.put_your_email') }}</p>
              <form @submit.prevent="validateBeforeSubmit" class="ls-form">
                <div class="ls-label" :class="{'ls-error': errors.has($t('login.mail')) }">
                  <div class="ls-prefix-group">
                    <span class="ls-label-text-prefix"><i class="fa fa-envelope-o" aria-hidden="true"></i></span>
                    <input
                      type="email"
                      v-validate="'required|email'"
                      v-model="email"
                      :placeholder="$t('login.mail')"
                      :name="$t('login.mail')" />
                  </div>
                  <small v-show="errors.has($t('login.mail'))" class="ls-help-message">{{ errors.first($t('login.mail')) }}</small>
                </div>
                <button class="ls-btn ls-btn-primary ls-btn-lg ls-full-width ls-md-margin-bottom">
                  <i v-show="!loading">{{ $t('login.send_link_to_my_email') }}</i>
                  <i v-show="loading">{{ $t('login.sending_link_to_my_email') }}</i>
                </button>
              </form>
              <p class="ls-txt-center">{{ $t('login.attributes.go_to_link') }} <br />
              <router-link :to="{ name: 'auth'}" :title="$t('login.signin')">{{ $t('login.signin') }}</router-link>
              </p>
            </div>
          </div>
      </div>
    </section>
</template>
<script>
  import { mapActions, mapMutations } from 'vuex'

  export default {
    data () {
      return {
        email: '',
        loading: false
      }
    },
    methods: {
      ...mapActions(['recoverPassword']),
      ...mapMutations(['clearFlash', 'setKeepFlash']),
      validateBeforeSubmit () {
        this.$validator.validateAll().then(success => {
          if (!success) return
          this.clearFlash()
          this.requestNewPassword()
          this.loading = true
        })
      },
      requestNewPassword () {
        this.$parent.$data.loading = true
        this.recoverPassword({ email: this.email }).then(this.afterRequest)
      },
      afterRequest (response) {
        this.setKeepFlash(true)
        this.$parent.$data.loading = false
        if (response.status !== 404) this.$router.push('/auth')
      }
    },
    mounted () {
      this.clearFlash()
    }
  }
</script>
<style lang="scss" scoped>
  .fade-enter-active, .fade-leave-active {
    transition: opacity 0.2s;
  }
  .fade-enter, .fade-leave-active {
    opacity: 0;
  }
  section {
    position: fixed;
    height: 100%;
    width: 100%;
  }
  .ls-prefix-group {
    margin: 1.5em 0 0 0;
  }
  .ls-error {
    .ls-label-text-prefix {
      color: #d75553!important;
      border-color: #d75553!important;
    }
  }
</style>



// WEBPACK FOOTER //
// RecoverPassword.vue?fa4b587a